import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface NewsletterApiParameter extends ApiParameter {
    newsletterForm: Partial<NewsletterFormModel>;
}

export interface NewsletterFormModel {
  firstName: string;
  lastName: string;
  jobTitle: string;
  company: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  typeOfWork: string;
  storeLocation: string;
  email: string;
}

const customUrl = "/api/NewsLetter/sendemail";

export async function subscribeNewsletterService(parameter: NewsletterApiParameter): Promise<ServiceResult<NewsletterFormModel>> {
    try {
        const result = await post<NewsletterFormModel>(`${customUrl}`, parameter.newsletterForm as NewsletterFormModel);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}